import "./LoginFormController"
import "./toolbar"
import angular from 'angular';

angular.module('security.login', ['security.login.form', 'security.login.toolbar']);